import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import Snack from '@/common/components/molecules/Snack/Snack';
import {
  ROUTE_SCANBAT_FORGOT_PASSWORD,
  ROUTE_SCANBAT_LOGIN,
  SCANBAT_REGEX,
} from '@/common/constants';
import { useModalContext } from '@/common/contexts/ModalContext';
import SessionStorageScanbat from '@/common/services/SessionStorage.scanbat';
import Scandit from '@/ebat/components/blocks/Modal/Common/Scandit/Scandit';

const useLogin = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const {
    setModalClassName,
    setModalContent,
    setModalIsOpen,
  } = useModalContext();

  const scanbatService = SessionStorageScanbat.getService();

  const onRemoveWarehouse = useCallback(() => {
    scanbatService.clearScanBat();
    history.push(ROUTE_SCANBAT_LOGIN);
  }, [history, scanbatService]);

  const onScanResult = useCallback(
    (scanResult) => {
      if (scanResult.barcodes.length > 0) {
        scanResult.barcodes.forEach((barcode) => {
          if (barcode.data.match(SCANBAT_REGEX)) {
            history.push(`?${barcode.data.split('?').pop()}`);
          } else {
            toast.error(
              <Snack message={t('common:messages:forms.errors.default')} />,
            );
          }

          setModalIsOpen(false);
        });
      }
    },
    [history, setModalIsOpen, t],
  );

  const onScanQrCode = useCallback(() => {
    setModalContent(<Scandit onScanResult={onScanResult} isLogin />);
    setModalClassName('modal-scandit');
    setModalIsOpen(true);
  }, [onScanResult, setModalClassName, setModalContent, setModalIsOpen]);

  const onOpenForgotPassword = useCallback(
    () => history.push(ROUTE_SCANBAT_FORGOT_PASSWORD),
    [history],
  );

  const onCloseForgotPassword = useCallback(
    () => history.push(ROUTE_SCANBAT_LOGIN),
    [history],
  );

  return {
    onCloseForgotPassword,
    onOpenForgotPassword,
    onRemoveWarehouse,
    onScanQrCode,
  };
};

export default useLogin;
